module.exports = __webpack_public_path__ + "static/banner-curve-1744d8efe42fc12dc37978968cbb2a05.png";